module.exports = __webpack_public_path__ + "static/media/circle-check.dbcc4817.svg";